import React from 'react';

import Spinner from 'components/shared/Spinner';

class SchoolyearsFilter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const button = e.currentTarget;
    const oldStatus = button.getAttribute('data-status');
    const newStatus = oldStatus == 'active' ? 'default' : 'active';
    const schoolyear = Number.parseInt(button.getAttribute('data-schoolyear'), 10);

    let active = this.props.value ? this.props.value.map(x => Number.parseInt(x, 10)) : []; // make sure they're int

    let index = active.indexOf(schoolyear);
    if (newStatus == 'active' && index == -1) {
      active.push(schoolyear);
      active.sort();
    }
    if (newStatus != 'active' && index != -1 ) {
      active.splice(index, 1);
    }

    if (this.props.onChange) {
      this.props.onChange(active);
    }
  }

  render() {
    let schoolyears = [];
    for (let y=2010; y<=(new Date()).getFullYear(); y++) {
      schoolyears.push({
        label: y + '/' + (parseInt(String(y).substring(2, 4))+1),
        value: y,
        status: this.props.value && (this.props.value.indexOf(y) !== -1 || this.props.value.indexOf(String(y)) !== -1) ? 'active' : 'default',
        isLast: y == (new Date()).getFullYear()
      });
    }

    let tabs = schoolyears.map((tab) => {
      var extraClass = '';
      switch (tab.status) {
        case 'active':
          extraClass = 'btn-primary active';
          break;
        case 'disabled':
        case 'busy':
          extraClass = 'btn-secondary disabled';
          break;
        case 'default':
        default:
          extraClass = 'btn-secondary default';
      }

      return (
        <button
          data-schoolyear={tab.value}
          data-status={tab.status}

          className={'btn' + (extraClass ? ' ' + extraClass : '') + (!tab.isLast ? ' mr-1' : '') + ' py-2 mb-1'}
          style={{
            position: 'relative',
            width: 'auto',
            minWidth: '0',
            fontSize: '95%',
            cursor: tab.status == 'default' ? 'pointer' : 'default'
          }}

          onClick={tab.status != 'disabled' && tab.status != 'busy' ? this.handleClick : () => false}
        >
          <i className={(tab.status == 'active' ? 'fa fa-circle' : 'far fa-circle') + ' mr-1'} /> {tab.label}
          {tab.status == 'busy' ? <span style={{position: 'absolute', left: 'calc(50% - 0.6em)'}}><Spinner message="" /></span> : ''}
        </button>
      );
    });

    return (
      <div className="mr-1">
        {tabs}
      </div>
    );
  }
}

export default SchoolyearsFilter;


// WEBPACK FOOTER //
// ./src/components/shared/filters/SchoolyearsFilter.js